module.exports = __webpack_public_path__ + "public/img/640 (3).f32e4f06.gif";